import Debug from 'debug';
import { configureStore, Tuple } from '@reduxjs/toolkit';
import { Entity, Row } from 'gossamer-unified';
import { cacheReducer, listInfoReducer, userReducer } from 'gossamer-front-end';

const debug = Debug('gfe/da/ReduxRoot');

let ENTITIES: Entity<any>[] | null = null;
export let store: any;

export const getEntity = (entityId: string) => {
  if (!ENTITIES) {
    throw new Error(`entities not initialized`);
  }
  const entity = ENTITIES.find((entity) => entity.id === entityId);
  if (!entity) {
    throw new Error(`entity not recognized: ${entityId}`);
  }
  return entity;
};

export const mapEntities = <T extends Row>(f: (entity: Entity<T>) => any) => {
  if (!ENTITIES) {
    return [];
  }
  return ENTITIES.map((entity) => f(entity as Entity<T>));
};

export const setReduxEntities = (entities: Entity<Row>[]) => {
  debug(`entities: ${entities.map((entity) => entity.id)}`);
  ENTITIES = entities;
};

export const makeStore = (middleware: () => Tuple<any>) => {
  debug(`inside makeStore()`);
  if (!ENTITIES) {
    throw new Error(`no Redux ENTITIES - setReduxEntities() not called yet?`);
  }
  if (store) {
    throw new Error(`makeStore already called`);
  }
  const reducer: Record<string, any> = {
    cache: cacheReducer,
    lists: listInfoReducer,
    user: userReducer,
  };
  store = configureStore({
    reducer,
    middleware,
  });
  // setInterval(() => {
  //   store.dispatch(cacheSweep({}));
  // }, 5 * 60 * 1000);

  return store;
};
